import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ChatRoom from './Chatroom';
import './ChatPage.css';
import MainNavbar from '../MainNavbar';
import OnlineUsers from './OnlineUsers';
import socket from '../../../../src/utils/socket'; // ✅ Use global socket (DO NOT redefine!)

const ChatPage = ({ userId }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [chattedUsers, setChattedUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);

  // ✅ Fetch current user
  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const response = await axios.get(
          `https://back.varankal.com/user/currentregister-details/${userId}`,
          { withCredentials: true }
        );
        setCurrentUser(response.data);

        // ✅ Connect socket once user is known
        if (!socket.connected) {
          socket.io.opts.query = { userId: response.data.userId };
          socket.connect();
        }
      } catch (error) {
        console.error('Error fetching current user:', error);
      }
    };
    fetchCurrentUser();
  }, [userId]);


  const fetchOnlineUsers = async () => {
    try {
      const response = await axios.get(`https://back.varankal.com/chats/online-users/${currentUser.userId}`);
      setOnlineUsers(response.data.onlineUsers);
    } catch (err) {
      console.error('Error fetching online users:', err);
    }
  };


  // 🔄 Poll online users from the backend API
  useEffect(() => {
    if (!currentUser?.userId) return;

    const loadOnlineUsers = () => {
      fetchOnlineUsers(currentUser.userId, (users) => {
        const filtered = users.filter(user =>
          user.userId !== currentUser.userId &&
          user.gender !== currentUser.basicDetails.gender
        );
        setOnlineUsers(filtered);
      });
    };

    loadOnlineUsers();
    const interval = setInterval(loadOnlineUsers, 15000); // Optional polling every 15 sec

    return () => clearInterval(interval);
  }, [currentUser]);


  const handleUserClick = (user) => {
    setSelectedUser(user);
  };

  const handleCloseChat = () => {
    setSelectedUser(null);
  };

  return (
    <>
      <MainNavbar />
      <div className='ChatPage00'>
        <div className="chat-page">
          <div className="online-users-container">
            <OnlineUsers allUsers={onlineUsers} />
          </div>

          <div>
            {selectedUser ? (
              <ChatRoom
                currentUser={currentUser}
                selectedProfile={selectedUser}
                onClose={handleCloseChat}
              />
            ) : (
              <p></p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatPage;
